/**
 * This file contains helpers functions used in the search component
 */
import * as query from "@arcgis/core/rest/query";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import Extent from '@arcgis/core/geometry/Extent';
import IdentifyParameters from "@arcgis/core/rest/support/IdentifyParameters.js";
import * as identify from "@arcgis/core/rest/identify.js";
import Graphic from "@arcgis/core/Graphic";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import { showAlert } from "../../../../utils/Helpers";
import { useTranslation } from "react-i18next";
import * as projection from "@arcgis/core/geometry/projection.js";
import SpatialReference from "@arcgis/core/geometry/SpatialReference.js";
// GLOBAL CACHE
const filtersCache = {};
const fieldValuesCache = {};

export const mapsearchQuery = async (qselectedLayers, queryOptions, mapview) => {

    const updatedQueryOptions = {
        ...queryOptions,
        returnGeometry: true,
        returnQueryGeometry: true,
        outFields: ["*"],
        outSpatialReference: 4326
    };
    try {

        let allQueryPromises = [];
        // if (qselectedLayers.length > 0) {
        //     qselectedLayers.forEach((qlayer) => {
        //         qlayer.layersIds.forEach((layerId, index) => {
        //             const qlayerUrl = qlayer.mapServiceUrl + '/' + layerId;
        //             const qlayerName = qlayer.layersNames[index];
        //             allQueryPromises.push(queryLayer(qlayerUrl, updatedQueryOptions, qlayerName, mapview));

        //         })
        //     })
        // }

        // const allresults = await Promise.all(allQueryPromises);
        // return allresults;

        const resultsByLayer = {};
        for (const layer of qselectedLayers) {
            //   const identifyTask = new identify.identify(layer.url);
            const params = new IdentifyParameters();
            params.geometry = queryOptions.geometry;
            params.mapExtent = mapview.extent;
            params.tolerance = 5;
            params.returnGeometry = true;
            params.layerOption = "all"; // Identify all sublayers
            params.spatialReference = mapview.spatialReference;

            try {
                const response = await identify.identify(layer.mapServiceUrl, params);
                const sublayerResults = {};
                response.results.forEach((result) => {
                    const sublayerName = result.layerName;

                    if (!sublayerResults[sublayerName]) {
                        sublayerResults[sublayerName] = { layerName: sublayerName, features: [] };
                    }
                    sublayerResults[sublayerName]['displayFieldName'] = result.displayFieldName
                    sublayerResults[sublayerName]['layerId'] = result.layerId
                    sublayerResults[sublayerName]["features"].push(result.feature);
                });
                const nullvalues = [...new Set(layer.layersNames.filter(item => !Object.keys(sublayerResults).includes(item)))]
                nullvalues.forEach((nullvalue) => {
                    sublayerResults[nullvalue] = { layerName: nullvalue, features: [] };
                })
                allQueryPromises.push(sublayerResults);
            } catch (error) {
                console.error("Identify task failed:", error);
            }
        }
        return allQueryPromises;
    } catch (error) {
        console.log('search query error: ', error);
        throw error;
    }
};

export const datasearchQuery = async (queryLayerUrl, queryOptions,t, mapview) => {
    try {
        let allQueryPromises = [];
        allQueryPromises.push(queryLayer(queryLayerUrl, queryOptions,t));

        const allresults = await Promise.all(allQueryPromises);
        return allresults;
    } catch (error) {
        console.log('search query error', error);
    }
};

export const queryLayer = async (qlayerUrl, queryOptions,t,qlayerName, LayerIds, mapview) => {
 
    try {

        const results = await query.executeQueryJSON(qlayerUrl, queryOptions);
        if (qlayerName) {
            return { [qlayerName]: results };
        } else {
            return results;
        }
    } catch (error) {
        console.log('search query error: ', error);
        showAlert(t('PleaseTryAgain'),"warning")
        throw error;
    }
}
export const zoomToResults = (qresults, mapview) => {
    let extents = [];
    if(qresults.length === 1 && qresults[0].geometry.type === 'point'){
        let point = qresults[0].geometry;
        if (point.spatialReference.isGeographic) {
            point = projection.project(point, { wkid: 3857 }); // Web Mercator
          }
        
          const buffer = geometryEngine.buffer(point, 200, "meters");
          let pointExtent = buffer.extent.expand(1.5);
        // Check if the point extent is valid
        if (pointExtent) {
            extents.push(pointExtent);
        } 
    }
    else if (qresults.length > 0) {
        

        // Gather extents from the geometry
        qresults.forEach(feature => {
            if (feature.geometry && feature.geometry.extent) {
                // Check if the extent is valid
                if (feature.geometry.extent) {
                    extents.push(feature.geometry.extent);
                } else {
                    console.warn('Invalid extent found for feature:', feature);
                }
            } else if (feature.geometry && feature.geometry.type === 'point') {
                const point = feature.geometry;
                const pointExtent = new Extent({
                    xmin: point.x - 1,
                    ymin: point.y - 1,
                    xmax: point.x + 1,
                    ymax: point.y + 1,
                    spatialReference: point.spatialReference
                });
              
                
                // Check if the point extent is valid
                if (pointExtent) {
                    extents.push(pointExtent);
                } else {
                    console.warn('Invalid extent created for point feature:', feature);
                }
            }
        });

        // Check if there are valid extents
        // if (extents.length > 0) {
        //     console.log('Extents to combine:', extents);

        //     // Combine extents into a single extent
        //     let combinedExtent = extents.reduce((acc, curr) => {
        //         if (acc && curr && acc.isValid && curr.isValid) {
        //             return geometryEngine.union(acc, curr);
        //         }
        //         return acc;
        //     }, extents[0]);

        //     // Check if the combined extent is valid
        //     if (combinedExtent) {
        //         console.log('Combined extent:', combinedExtent);
        //         mapview.goTo(combinedExtent).catch(error => {
        //             console.error('Error zooming to combined extent:', error);
        //         });
        //     } else {
        //         console.warn('Combined extent is invalid.');
        //     }
        // } 
       
        
    } else {
        console.warn('No results available to zoom to.');
    }
    if (extents.length > 0) {

        // 1. Filter out invalid extents first
        const validExtents = extents.filter(extent => {
            return extent &&
                typeof extent.xmin === 'number' &&
                typeof extent.ymin === 'number' &&
                typeof extent.xmax === 'number' &&
                typeof extent.ymax === 'number' &&
                extent.xmin <= extent.xmax &&
                extent.ymin <= extent.ymax;
        });

        if (validExtents.length === 0) {
            console.warn("No valid extents to combine.");
            return;
        }

        // 2. Use `geometryEngine.union()` in a reduce
        let combinedExtent = validExtents.reduce((acc, curr) => {
            try {
                // `geometryEngine.union()` returns a NEW extent (no in-place modification)
                const unioned = geometryEngine.union(acc, curr);
                return unioned || acc; // Fallback to `acc` if union fails
            } catch (error) {
                console.warn("Union failed, skipping extent:", error);
                return acc; // Return previous valid extent
            }
        }, validExtents[0]); // Start with the first valid extent

        // 3. Final check before zooming
        if (combinedExtent) {
            console.log("Final combined extent:", combinedExtent);
            mapview.goTo({
                target: combinedExtent,
                padding: 50  // Ensures features aren't cut off
            }).catch(error => {
                console.error("Zoom error:", error);
            });
        } else {
            console.warn("Combined extent is invalid.");
        }
    }else {
        console.warn('No valid extents available for zooming.');
    }
};

const getSelectedLayers = async (mapSearchRef) => {
    if (mapSearchRef.current) {
        const selectedItems = mapSearchRef.current.getSelectedItems();
        return selectedItems;
    } else {
        return [];
    }
};

export const clipFeatures = async (graphicsLayer, features, mapView, geom, mapSearchRef, activeSearch) => {
    if (!graphicsLayer || !features || features.length === 0) {
        console.warn('No graphics layer or features to clip.');
        return;
    }
    function Featuresclip(features, clipPolygon) {
        return features.map(feature => {
            if (!feature.geometry) {
                // If feature has no geometry, just skip
                return null;
            }
            const clippedGeom = geometryEngine.intersect(feature.geometry, clipPolygon);
            if (clippedGeom) {
                const graphic = new Graphic({
                    geometry: clippedGeom,
                    attributes: feature.attributes,
                    // symbol: sourceLayer.renderer.getSymbol(feature)
                    symbol: {
                        type: "simple-fill",
                        color: [0, 255, 0, 0.3], // Semi-transparent green fill
                        style: "solid",
                        outline: {
                            color: "#1b8096",
                            width: 1
                        }
                    }
                });
                return graphic;
            }
            return null;
        }).filter(graphic => graphic !== null);
    }


    // Clear existing graphics
    graphicsLayer.graphics.removeAll();

    // Process all features from all habitat types
    let allFeatures = [];
    activeSearch === "map" ?
        features.forEach(habitatType => {
            for (const [key, value] of Object.entries(habitatType)) {
                if (value.features && value.features.length > 0) {
                    allFeatures = allFeatures.concat(value.features);
                }
            }
        }) :
        features.forEach(habitatType => {
            if (habitatType.features && habitatType.features.length > 0) {
                allFeatures = allFeatures.concat(habitatType.features);
            }
        });

    const clippedFeatures = activeSearch === "map" ? Featuresclip(allFeatures, geom) : allFeatures;
    const qselectedLayers = activeSearch === "map" ? await getSelectedLayers(mapSearchRef) : [{ mapServiceUrl: mapSearchRef.current.queryLayerUrl }];

    function removeDuplicates(layersInfo) {
        layersInfo.forEach(info => {
            // Create a paired array to maintain correspondence between layersIds and layersNames
            const paired = info.layersIds?.map((id, index) => ({
                id: id,
                name: info.layersNames ? info.layersNames[index] : undefined
            }));

            // Remove duplicates based on both id and name
            const uniquePairs = [...new Map(paired.map(item =>
                [`${item.id}-${item.name}`, item])).values()];
            // Update layersIds and layersNames with unique values
            info.layersIds = uniquePairs.map(pair => pair.id);
            info.layersNames = uniquePairs.map(pair => pair.name);
        });
    }
    if (activeSearch === "map") {
        removeDuplicates(qselectedLayers)

        const flattenedLayers = [];
        qselectedLayers.forEach(info => {
            if (info.mapServiceName === "Historical Permits") {
                [1,2,4,5,6].forEach((layerId) => {
                    flattenedLayers.push({
                        mapServiceId: info.mapServiceId,
                        mapServiceUrl: info.mapServiceUrl,
                        layerId: layerId,
                        layerName: info.mapServiceName
                    });
                })
            }
            else {
                info.layersIds.forEach((id, index) => {
                    flattenedLayers.push({
                        mapServiceId: info.mapServiceId,
                        mapServiceUrl: info.mapServiceUrl,
                        layerId: id,
                        layerName: info.layersNames[index]
                    });
                });
            }

        });
        qselectedLayers.forEach((sublayer, index) => {
            // Get the corresponding layer info from flattenedLayers
            const layerInfo = flattenedLayers[index];
            if (!layerInfo) {
                console.warn(`No matching layer info for qselectedLayers index: ${index}`);
                return;
            }

            // Load the FeatureLayer for the specific layerId without adding to map
            const featureLayer = new FeatureLayer({
                url: `${layerInfo.mapServiceUrl}/${layerInfo.layerId}`
            });

            // Wait for the layer to load to access its renderer
            featureLayer.load().then(() => {
                const renderer = featureLayer.renderer;

                if (renderer) {
                    clippedFeatures.forEach((clippedFeature) => {
                        let symbol = null;

                        // Process all layers dynamically (no static layer name check)
                        if (renderer.type === "simple") {
                            // SimpleRenderer: Use the single symbol
                            symbol = renderer.symbol;
                        } else if (renderer.type === "unique-value") {
                            // UniqueValueRenderer: Match the feature's attribute to the correct symbol
                            const field = renderer.field;
                            const featureValue = clippedFeature.attributes[field];
                            const uniqueValueInfo = renderer.uniqueValueInfos.find(
                                (info) => parseInt(info.value) === featureValue || info.value === featureValue
                            );
                            symbol = uniqueValueInfo
                                ? uniqueValueInfo.symbol
                                : renderer.uniqueValueInfos.length === 1
                                    ? renderer.uniqueValueInfos[0].symbol
                                    : renderer.defaultSymbol;
                        } else if (renderer.type === "class-breaks") {
                            // ClassBreaksRenderer: Match the feature's attribute to the correct class break
                            const field = renderer.field;
                            const featureValue = clippedFeature.attributes[field];
                            const classBreakInfo = renderer.classBreakInfos.find(
                                (info) => featureValue >= info.minValue && featureValue <= info.maxValue
                            );
                            symbol = classBreakInfo
                                ? classBreakInfo.symbol
                                : renderer.defaultSymbol;
                        }

                        // Apply the symbol to the clipped feature
                        if (symbol) {
                            clippedFeature.symbol = symbol;
                            clippedFeature.layerName = layerInfo.layerName; // Use layer name from layersInfo
                        } else {
                            console.warn(`No symbol found for feature in layer: ${layerInfo.layerName}`);
                        }
                        graphicsLayer?.graphics.add(clippedFeature);
                    });
                } else {
                    console.warn(`No renderer found for layer: ${layerInfo.layerName}`);
                }
            }).catch(error => {
                console.error(`Failed to load layer ${layerInfo.layerName} with ID ${layerInfo.layerId} from ${layerInfo.mapServiceUrl}:`, error);
            });
        });
    }
    else {
        qselectedLayers.forEach((sublayer, index) => {
            if (!sublayer) {
                console.warn(`No matching layer info for qselectedLayers index: ${index}`);
                return;
            }

            // Load the FeatureLayer for the specific layerId without adding to map
            const featureLayer = new FeatureLayer({
                url: `${sublayer.mapServiceUrl}`
            });

            // Wait for the layer to load to access its renderer
            featureLayer.load().then(() => {
                const renderer = featureLayer.renderer;

                if (renderer) {
                    clippedFeatures.forEach((clippedFeature) => {
                        let symbol = null;

                        // Process all layers dynamically (no static layer name check)
                        if (renderer.type === "simple") {
                            // SimpleRenderer: Use the single symbol
                            symbol = renderer.symbol;
                        } else if (renderer.type === "unique-value") {
                            // UniqueValueRenderer: Match the feature's attribute to the correct symbol
                            const field = renderer.field;
                            const featureValue = clippedFeature.attributes[field];
                            const uniqueValueInfo = renderer.uniqueValueInfos.find(
                                (info) => parseInt(info.value) === featureValue || info.value === featureValue
                            );
                            symbol = uniqueValueInfo
                                ? uniqueValueInfo.symbol
                                : renderer.uniqueValueInfos.length === 1
                                    ? renderer.uniqueValueInfos[0].symbol
                                    : renderer.defaultSymbol;
                        } else if (renderer.type === "class-breaks") {
                            // ClassBreaksRenderer: Match the feature's attribute to the correct class break
                            const field = renderer.field;
                            const featureValue = clippedFeature.attributes[field];
                            const classBreakInfo = renderer.classBreakInfos.find(
                                (info) => featureValue >= info.minValue && featureValue <= info.maxValue
                            );
                            symbol = classBreakInfo
                                ? classBreakInfo.symbol
                                : renderer.defaultSymbol;
                        }

                        // Apply the symbol to the clipped feature
                        if (symbol) {
                            clippedFeature.symbol = symbol;
                            clippedFeature.layerName = sublayer.mapServiceUrl; // Use layer name from layersInfo
                        } else {
                            console.warn(`No symbol found for feature in layer: ${sublayer.mapServiceUrl}`);
                        }
                        graphicsLayer?.graphics.add(clippedFeature);
                    });
                } else {
                    console.warn(`No renderer found for layer: ${sublayer.mapServiceUrl}`);
                }
            }).catch(error => {
                console.error(`Failed to load layerfrom ${sublayer.mapServiceUrl}:`, error);
            });
        });
    }

};

// export const zoomToResults = (qresults, mapview) => {
//     if (qresults.length > 0) {
//         let extents = qresults.map(feature => feature.geometry.extent).filter(extent => extent !== null);
//         qresults.forEach(feature => {
//             if (feature.geometry.type === 'point') {
//                 const point = feature.geometry;
//                 extents.push(new Extent({
//                     xmin: point.x - 1,
//                     ymin: point.y - 1,
//                     xmax: point.x + 1,
//                     ymax: point.y + 1,
//                     spatialReference: point.spatialReference
//                 }));
//             }
//         });
//         if (extents.length > 0) {
//             const combinedExtent = extents.reduce((acc, curr) => geometryEngine.union(acc, curr), extents[0]);

//             // Zoom to the combined extent
//             mapview.goTo(combinedExtent).catch(error => {
//                 console.error('Error zooming to combined extent:', error);
//             });
//         } else {
//             console.warn('No valid extents available for zooming');
//         }
//        // mapview.goTo(qresults);
//     }
// }

export const highlightResults = (qresults, mapview) => {
    // console.log('zoom to qresults', qresults)
    // if (qresults.length > 0) {
    //     // mapview.goTo(qresults[0].geometry);
    // }
}

export const removeGraphics = (mapview, sketchGLayer = undefined) => {
    if (sketchGLayer) {
        sketchGLayer.graphics.removeAll();
    }
    const graphicsLayer = mapview.map.findLayerById('searchDrawGLayer');
    if (!graphicsLayer) return;
    graphicsLayer.graphics.removeAll();
}

export const groupLayers = (dataLayers) => {
    let groupedData = [];
    dataLayers.filter(ilayer => ilayer.type != 'graphics').map((layer) => {
        if (layer.layers?.items.length > 0 || layer.sublayers?.items.length > 0) {
            let childLayers = layer.layers ?? layer.sublayers;
            let dataItems = [];
            {
                childLayers.items.map((sublayer) => {
                    dataItems.push({
                        id: sublayer.id,
                        layerName: sublayer.title,
                        url: sublayer.url,
                        layer: sublayer,
                    })
                })
            }
            groupedData.push({
                id: layer.id,
                mapServiceName: layer.title,
                url: layer.url,
                items: dataItems,
            });
        } else {
            groupedData.push({
                id: layer.id,
                mapServiceName: layer.title,
                url: layer.url,
                layer: layer,
            });
        }
    });
    return groupedData;
}
export function doPaginationQuery(layerUrl, queryObject, queryMaxRecordCount) {
    let start = 0;
    let pFeatures = []

    // console.log('helpers: pagination query: ', queryObject)
    const runQuery = (start, num) => {
        const pQuerylayerUrl = layerUrl;
        const pQuery = {
            start: start,/**resultOffset */
            num: num ?? queryMaxRecordCount ?? 2000,/**resultRecordCount */
            where: queryObject.where ?? "1=1",
            outFields: queryObject.outFields ?? ["*"],
            returnGeometry: queryObject.returnGeometry ?? false,
            orderByFields: queryObject.orderByFields
        };
        return (query.executeQueryJSON(pQuerylayerUrl, pQuery).then((res) => {
            pFeatures = pFeatures.concat(res.features);

            if (res.exceededTransferLimit) {
                start += res.features.length
                return runQuery(start);

            } else {
                return { data: pFeatures, error: null };
            }
        }).catch((error) => {
            console.log('helpers: pagination query error: ', error)
            return { data: null, error: error.message };
        }));
    }
    return Promise.resolve(runQuery(start));
}

export const getActiveMapservices = async () => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/PortalConfig/activeMapServices`, {
            method: "GET",
        }
        )
        if (!response.ok) {
            const errorText = await response.json();
            throw new Error(`${response.status}: ${errorText.message}`);
        }
        const data = await response.json();
        return { data, error: null };
    }
    catch (error) {
        return { data: null, error: error.message };
    }
}

export const getPublicMapservices = async () => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/PortalConfig/publicMapServices`, {
            method: "GET",
        }
        )
        if (!response.ok) {
            const errorText = await response.json();
            throw new Error(`${response.status}: ${errorText.message}`);
        }
        const data = await response.json();
        return { data, error: null };
    }
    catch (error) {
        return { data: null, error: error.message };
    }
}

export const getUserMapservices = async (fetchDataWithAuth, userID, navigate, t) => {
    try {
        const response = await fetchDataWithAuth(
            `/PortalConfig/userMapServices/${userID}`,
            "GET",
            navigate,
            t
        )
        return { data: response, error: null };
    }
    catch (error) {
        return { data: null, error: error.message };
    }
}

export const getQueryLayers = async (mapServiceID) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/PortalConfig/queries/mapservice/${mapServiceID}`, {
            method: "GET",
        }
        )
        if (!response.ok) {
            const errorText = await response.json();
            throw new Error(`${response.status}: ${errorText.message}`);
        }
        const data = await response.json();
        return { data, error: null };
    }
    catch (error) {
        return { data: null, error: error.message };
    }
}

// export const getFilters = async (queryID) => {
//     try {
//         const response = await fetch(
//             `${process.env.REACT_APP_API_URL}/PortalConfig/queryfilters/queryId/${queryID}`, {
//             method: "GET",
//         }
//         )
//         if (!response.ok) {
//             const errorText = await response.json();
//             throw new Error(`${response.status}: ${errorText.message}`);
//         }
//         const data = await response.json();
//         return { data, error: null };
//     }
//     catch (error) {
//         return { data: null, error: error.message };
//     }
// }
export const getFilters = async (queryID) => {
    if (filtersCache[queryID]) {
        return { data: filtersCache[queryID], error: null };
    }

    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/PortalConfig/queryfilters/queryId/${queryID}`, 
            { method: "GET" }
        );

        if (!response.ok) {
            const errorText = await response.json();
            throw new Error(`${response.status}: ${errorText.message}`);
        }

        const data = await response.json();
        filtersCache[queryID] = data;    // ⭐ store in cache

        return { data, error: null };
    }
    catch (error) {
        return { data: null, error: error.message };
    }
}
export const getFieldValues = async (layerUrl, fieldsArray) => {

    const queryFieldValues = async (field) => {

        const cacheKey = `${layerUrl}_${field}`;

        // ⭐ Return from cache instantly if available
        if (fieldValuesCache[cacheKey]) {
            return {
                field,
                values: fieldValuesCache[cacheKey],
                warning: null
            };
        }

        try {
            const fieldValuesQuery = {
                where: "1=1",
                groupByFieldsForStatistics: [field],
                outStatistics: [{
                    statisticType: "count",
                    onStatisticField: field,
                    outStatisticFieldName: "cnt"
                }],
                returnGeometry: false
            };

            const result = await query.executeQueryJSON(layerUrl, fieldValuesQuery);
            const distinctValues = [...new Set(result.features.map(f => f.attributes[field]))];

            // ⭐ Save to cache
            fieldValuesCache[cacheKey] = distinctValues;

            return { field, values: distinctValues, warning: null };

        } catch (error) {
            return { field, values: null, error: error.message };
        }
    };

    const results = await Promise.all(fieldsArray.map(queryFieldValues));

    const finalResult = {};
    results.forEach(r => {
        finalResult[r.field] = { values: r.values, warning: null, error: r.error };
    });

    return finalResult;
};

// export const getFieldValues = async (layerUrl, fieldsArray) => {
//     const queryFieldValues = async (field) => {
//         try {
//             const fieldValuesQuery = {
//                 where: "1=1",
//                 outFields: [field],
//                 //returnDistinctValues: true,
//                 groupByFieldsForStatistics: [field],
//                 outStatistics: [{
//                   statisticType: "count",
//                   onStatisticField: field,
//                   outStatisticFieldName: "cnt"
//                 }],
//                 returnGeometry: false
//             };
//             const result = await query.executeQueryJSON(layerUrl, fieldValuesQuery);
//             const distinctValues = new Set();

//             result.features.forEach(feature => {
//                 distinctValues.add(feature.attributes[field]);
//             });

//             return {
//                 field,
//                 values: Array.from(distinctValues),
//                 warning: null
//             };
//         } catch (error) {
//             console.error(`Error querying field ${field}: `, error);
//             return { field, values: null, error: error.message };
//         }
//     };

//     try {
//         const promises = fieldsArray.map(field => queryFieldValues(field));
//         const results = await Promise.all(promises);

//         const response = results.reduce((acc, { field, values, warning, error }) => {
//             acc[field] = { values, warning, error };
//             return acc;
//         }, {});

//         return response;

//     } catch (error) {
//         console.error("Error querying fields: ", error);
//         return { error: error.message };
//     }
// };